import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect, memo } from 'react';
const HomeModal = ({ modalList, width, height }) => {
  //App.js에서 호출함
  const [showModalList, setShowModalList] = useState([]);
  console.log(modalList);
  // console.log(`modal-${modalList[0].width}w`);
  useEffect(() => {
    const booleanList = [true];
    for (let i = 0; i < modalList.length - 1; i++) {
      booleanList.push(false);
    }
    // console.log(modalList.length);
    // console.log(booleanList);
    setShowModalList(booleanList);
  }, [modalList]);

  const changeList = () => {
    //[false, true, false, false, false]
    // console.log('modalList');
    // console.log(showModalList);
    const index = showModalList.indexOf(true);
    const booleanList = [];
    if (index === showModalList.length - 1) {
      for (let i in showModalList) {
        booleanList.push(false);
      }
      // console.log('마지막인 경우, ');
      // console.log(booleanList);
      setShowModalList(booleanList);
      return booleanList;
    } else {
      for (let i = 0; i <= index; i++) {
        booleanList.push(false);
      }
      booleanList.push(true);
      for (let i = index + 1; i < showModalList.length - 1; i++) {
        booleanList.push(false);
      }
      // console.log('그 외의 경우,');
      // console.log(booleanList);
      setShowModalList(booleanList);
      return booleanList;
    }
  };
  return (
    <div>
      {modalList.map((modal, key) => {
        return (
          <Modal
            centered
            show={showModalList[key]}
            key={key}
            dialogClassName={`modal-${modal.size}`}
            onHide={() => changeList()}
          >
            <Modal.Header closeButton>
              <Modal.Title>{modal.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body dangerouslySetInnerHTML={{ __html: modal.content }}></Modal.Body>
          </Modal>
        );
      })}

      {/* <Modal show={show2} onHide={() => setShow2(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShow2(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};
export default memo(HomeModal);
